import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useScroll } from "../../scroll/ScrollProvider";

/**
 * BhutanTribute — respectful visual homage for the Bhutan section:
 * layered Himalayan silhouettes, a radiant crest ring, and a golden jewel.
 */
export function BhutanTribute() {
  const root = useRef<THREE.Group>(null);
  const halo = useRef<THREE.Mesh>(null);
  const { section, sectionProgress } = useScroll();

  useFrame((_state, delta) => {
    const active = section < 9 ? 0 : section === 9 ? sectionProgress : 1;
    if (root.current) {
      root.current.rotation.y = -0.08 + active * 0.12;
      root.current.position.y = Math.sin(performance.now() * 0.0004) * 0.05;
    }
    if (halo.current) halo.current.rotation.z += delta * 0.16;
  });

  return (
    <group ref={root}>
      <mesh position={[0, -0.55, -0.2]}>
        <coneGeometry args={[2.1, 1.6, 3]} />
        <meshStandardMaterial color="#12161f" metalness={0.15} roughness={0.82} />
      </mesh>
      <mesh position={[0, -0.35, 0.35]}>
        <coneGeometry args={[1.6, 1.2, 3]} />
        <meshStandardMaterial color="#1a202c" metalness={0.2} roughness={0.78} />
      </mesh>

      <mesh position={[0, 0.4, 0]}>
        <octahedronGeometry args={[0.38, 0]} />
        <meshStandardMaterial
          color="#f0cb78"
          metalness={1}
          roughness={0.2}
          emissive="#3a2a0a"
          emissiveIntensity={0.45}
          toneMapped={false}
        />
      </mesh>

      <mesh ref={halo} rotation={[Math.PI / 2, 0, 0]} position={[0, 0.35, 0]}>
        <torusGeometry args={[0.95, 0.03, 16, 110]} />
        <meshStandardMaterial color="#e7c98a" metalness={1} roughness={0.25} emissive="#2a1f08" emissiveIntensity={0.4} />
      </mesh>

      <pointLight position={[0, 0.7, 0.8]} intensity={1.5} color="#ffd78a" distance={6} decay={2} />
      <pointLight position={[0, 0.2, -1]} intensity={0.7} color="#8daeff" distance={5} decay={2} />
    </group>
  );
}
